import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-text-input-dialog',
  templateUrl: './text-input-dialog.component.html',
  styleUrls: ['./text-input-dialog.component.css']
})
export class TextInputDialogComponent {

  freeTextValue: string;
  
  get freeTextPrompt(): string {
    return this.data.freeTextPrompt || '';
  }

  constructor(
    public dialogRef: MatDialogRef<TextInputDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  public okClick() {
    this.dialogRef.close(this.freeTextValue);
  }

  public cancelClick() {
    this.dialogRef.close();
  }

}
